









import { Component, Prop, Vue } from "vue-property-decorator";
import { SecurityService } from "@/services/SecurityService";
import CreateSessionResultModel from "@/models/security/zorgID/createSessionResultModel";
import SessionOpenedViewModel from "@/models/security/zorgID/sessionOpenedViewModel";
import SecureElementComponent from "@/components/zorgID/SecureElementComponent.vue";
import { Getter } from "vuex-class";
import { ApplicationConfiguration } from "@/types/store";

@Component({
  components: {
    SecureElementComponent,
  },
})
export default class OpenSessionComponent extends Vue {
  @Prop() private enableUI!: boolean;

  @Getter("applicationConfiguration")
  applicationConfiguration!: ApplicationConfiguration;

  private sessionOpenedViewModel: SessionOpenedViewModel = new SessionOpenedViewModel();

  private isSessionOpened: boolean = false;

  private sessionId: string = "";

  private created() {
    this.subscribeToEvents();
  }

  private subscribeToEvents(): void {
    var me = this;
    SecurityService.getInstance().subscribeSessionOpenedReceived(x => {
      me.sessionOpened(x);
    });
  }

  public openSession(model: CreateSessionResultModel) {
    var me = this;
    me.isSessionOpened = false;
    me.sessionId = "";
    me.sessionOpenedViewModel = new SessionOpenedViewModel();

    if (model.Nonce != "SIMULATED") {
      var hrefNonce =
        "ZORGID://s?n=" +
        model.Nonce +
        "&e=" +
        this.applicationConfiguration.zorgIDEnvironmentCode;
      window.location.href = hrefNonce;
    }
  }

  private sessionOpened(model: SessionOpenedViewModel) {
    var me = this;
    me.sessionOpenedViewModel = model;
    // Security service does the 'real' handling of session opened
    me.isSessionOpened = true;
    me.sessionId = me.sessionOpenedViewModel.SessionId;
    me.$emit("sessionOpened");
  }
}
